// Lê o arquivo escolhido na importação de leads frios. XLSX carrega
// read-excel-file só aqui (import dinâmico, fora do bundle principal);
// CSV/TSV/TXT vão direto para o papaparse.
import { matrixToRecords, parseDelimitedText, type SheetRecords } from "./sheetImport";

export const SPREADSHEET_ACCEPT =
  ".csv,.tsv,.txt,.xlsx,text/csv,text/tab-separated-values,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export async function readSpreadsheet(file: File): Promise<SheetRecords> {
  if (/\.xlsx$/i.test(file.name)) {
    const { readSheet } = await import("read-excel-file/universal");
    return matrixToRecords(await readSheet(file));
  }
  return parseDelimitedText(await file.text());
}
